import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'
import Download from '../views/Download/Download.vue'
import Router from 'vue-router';

Vue.use(Router);
Vue.use(VueRouter)

const router = new Router({
  mode: 'hash', // 使用 history 模式
  routes: [
    // 定义你的路由配置
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/download',
      name: 'download',
      component: Download,
    },
  ],
});

// router.beforeEach((to, from, next) => {
//   console.log('From:', from.name);
//   console.log('To:', to.name);
//   // 检查是否从Home页面跳转到Download页面
//   if (from.name != 'home' && to.name === 'download') {
//     next('/') // 允许访问Download页面
//   } else {
//     next()
//   }
// })



export default router